import React from 'react';
import { useNavigate } from 'react-router-dom';
import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import { useLang } from './i18n/context';
import './Login.css';

function AuthContainer({ page }) {
  const navigate = useNavigate();
  const { t } = useLang();

  let content = null;
  if (page === 'login') content = <Login />;
  else if (page === 'register') content = <Register />;
  else if (page === 'forgot') content = <ForgotPassword />;

  return (
    <div className="auth-page">
      <div className="auth-gradient" />
      <button className="auth-back" onClick={() => navigate('/')}>
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
          <path d="M19 12H5M12 5l-7 7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        {t('docs.backToHome').replace('← ', '')}
      </button>
      {content}
    </div>
  );
}

export default AuthContainer;
